import reduceReducers from 'reduce-reducers'
import { makeApiTypes } from 'sidecar-utility-library'

import { default as GroupReducer } from './group'

export * from './group'

export const types = {
  ...makeApiTypes('FETCH_GROUP_INFO', 'groups'),
  ...makeApiTypes('FETCH_GROUP_LOGOS', 'groups'),
  CLEAR_GROUP_INFO: 'groups/CLEAR_GROUP_INFO',
}

export const initialState = {
  group: {
    busy: false,
    error: '',
    info: {},
  },
}

export default reduceReducers(
  GroupReducer,
  // initialState must be the last arg
  initialState,
)
